<template>
  <div class="plans-total-data-section">
    <div class="cell">
      <div class="number">{{ total }}<span> ₪</span></div>
      <div>{{ totalAmountText }}</div>
    </div>
    <div class="horizontal-separator-container">
      <div class="horizontal-separator"></div>
    </div>
    <div class="cell">
      <div class="number">{{ plans.length }}</div>
      <div>{{ plansLengthText }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moneyUtils from '@/utils/money';

export default {
  name: 'PlansTotalDataSection',
  computed: {
    ...mapState('planAhead', ['plans']),
    ...mapGetters('planAhead', ['totalPlansMonthlyAmount']),
    total() {
      return moneyUtils.formatAmountWithFraction(this.totalPlansMonthlyAmount, 0);
    },
    totalAmountText() {
      return 'רוצה לשים בחודש';
    },
    plansLengthText() {
      return 'מספר תוכניות ';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import './plan-ahead';

.plans-total-data-section {
  display: flex;
  height: 120px;
  border: 1px solid $riseup_gray_0;
  box-shadow: 2px 2px 8px rgba(186, 188, 191, 0.25);
  border-radius: 8px;
  position: absolute;
  top: calc(#{$top-section-height} - 60px);
  width: 340px;
  margin: 0 auto;
  background: $riseup_white;

  .cell {
    display: flex;
    align-items: center;
    flex: 1;
    flex-direction: column;
    justify-content: center;

    .number {
      font-size: 48px;
      padding-bottom: 4px;

      span {
        font-size: 18px;
      }
    }
  }

  .horizontal-separator-container {
    margin: 24px 0;

    .horizontal-separator {
      border: 1px solid $riseup_gray_disabled;
      height: 100%;
    }
  }
}
</style>
